import { Card, Grid, Stack } from '@mui/material';
import { useGetBankingInfo } from '@/hooks/requests/useBankingInfo';
import AdvisorDashboardRateCards from './AdvisorDashboardRateCards';
import AdvisorDashboardActiveApplications from './AdvisorDashboardActiveApplications';
import AdvisorDashboardBankRates from './AdvisorDashboardBankRates';
import AdvisorDashboardAvailableBalance from './AdvisorDashboardAvailableBalance';
import AdvisorDashboardHeader from './AdvisorDashboardHeader';
import AdvisorDashboardTopAccounts from './AdvisorDashboardTopAccounts';
import AdvisorDashboardRecentlyOpenedAccounts from './AdvisorDashboardRecentlyOpenedAccounts';
import AdvisorDashboardInterestCalculator from './AdvisorDashboardInterestCalculator';
import AdvisorDashboardRecentTransactionRequests from './AdvisorDashboardRecentTransactionRequests';
import { SVLoader } from '@/components/core';

export default function AdvisorDashboardLayout() {
  const { bankingInfo, isPending } = useGetBankingInfo();

  if (isPending) {
    return (
      <>
        <AdvisorDashboardHeader />
        <Card>
          <SVLoader />
        </Card>
      </>
    );
  }

  return (
    <>
      <AdvisorDashboardHeader />
      <Grid container spacing={2}>
        <Grid container size={{ xs: 12, md: 6 }}>
          <Stack spacing={2} sx={{ width: '100%' }}>
            {bankingInfo && (
              <>
                <AdvisorDashboardRateCards bankingInfo={bankingInfo} />
                <AdvisorDashboardAvailableBalance bankingInfo={bankingInfo} />
              </>
            )}
            <AdvisorDashboardTopAccounts />
            <AdvisorDashboardRecentlyOpenedAccounts />
          </Stack>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Stack spacing={2}>
            {bankingInfo && (
              <AdvisorDashboardActiveApplications bankingInfo={bankingInfo} />
            )}
            <AdvisorDashboardRecentTransactionRequests />
            {bankingInfo && (
              <>
                <AdvisorDashboardBankRates bankingInfo={bankingInfo} />
                <AdvisorDashboardInterestCalculator bankingInfo={bankingInfo} />
              </>
            )}
          </Stack>
        </Grid>
      </Grid>
    </>
  );
}
